export default __webpack_public_path__ + "static/media/logo-square.2466fc7f.png";